import { useCallback, useState } from 'react'

import { patch } from '@/services/general/patch'

export const useContractsPatch = () => {
  const [isLoading, setIsLoading] = useState(false)

  const contractPatch = useCallback(
    async ({ contractId, userId }: { contractId: string; userId: string }) => {
      try {
        setIsLoading(true)

        if (!contractId) {
          return {
            sucesso: false,
            conteudo: 'Número do contrato é obrigatório'
          }
        }

        const response = await patch({
          contractId,
          novoStatus: 3,
          idUsuario: userId
        })

        return response
      } catch (error) {
        return error
      } finally {
        setIsLoading(false)
      }
    },
    []
  )

  return { contractPatch, isLoading }
}
